/**
 * The rows of a links field as a form holds them — one string per row, blanks
 * and all. Shared by the idea, event, flight-group and accommodation form
 * cores, which offer the same add/edit/remove list and send the same array of
 * URLs.
 */

/** How many links a stay or a flight group may carry; an event takes five (its create flow's core holds that cap), an idea any number. */
export const MAX_LINKS = 3

/** The URLs a saved entity's links carry, in order. */
export const linkUrls = (links: { url: string }[] | null | undefined): string[] =>
	links?.map(link => link.url) ?? []

/** A new, empty row at the end of the list. */
export const addLinkRow = (links: string[]): string[] => [...links, '']

export const setLinkRow = (links: string[], index: number, value: string): string[] =>
	links.map((link, i) => (i === index ? value : link))

export const removeLinkRow = (links: string[], index: number): string[] =>
	links.filter((_, i) => i !== index)

/**
 * The rows that reach the wire: trimmed, with the blank ones dropped. Trimming
 * here rather than at each call site is what keeps a create and a later edit
 * sending the same URL for the same typing.
 */
export const compactLinks = (links: string[]): string[] =>
	links.map(link => link.trim()).filter(link => link !== '')

/** Whether two lists of links hold the same URLs in the same order. */
export const sameLinks = (a: string[], b: string[]): boolean =>
	a.length === b.length && a.every((link, index) => link === b[index])
